import { deleteHeziFile } from '@remote/api/adapter/shell-mqtt'
import { checkState } from '@remote/store/utils'
import { isBuildInPath } from '@remote/store/hezi-file/disk'
import Modal from '@remote/components/modal'
import { toast } from '@remote/utils/dialog'
import { getDramas as getDramasApi } from '@remote/api/nfo'
import { store } from '@remote/store'
import { reduceFilename } from '@remote/utils'
import { interceptDigital } from '@remote/utils/base'
import EventEmitter from '@remote/utils/event-emitter'

export const cinemaEventBusEvents = {
  modifyCinema: 'modify-cinema',
}
export const cinemaEventBus = new EventEmitter( [cinemaEventBusEvents.modifyCinema])

// 从片库删除影片
export const deleteNFO = async (
  nfo: API_NFO.NFO, 
  deleteNFOFromCinemaStore: Function, 
  isPlayHistory?: boolean, 
  deleteNFOSuccessCallback?:Function,
) => {
  if (isPlayHistory) {
    // 删除最近观看记录
    Modal.Delete({
      title: '确认删除该播放记录吗？',
      cancelText: '取消',
      okText: '立即删除',
      loadingText: '删除中...',
      onOk: () => {
        toast('开发中...')
      },
    })
    // todo
    console.log('只做删除播放记录操作')
    return
  } else {
    // 删除剧集
    const isTV = nfo.scrape_result?.class === 'tv'
    const videoInfo = nfo.video_info as { real_path: string; file_id: string }
    const inBuildInDiskPaths: string[] = []
    const notInBuildInDiskPaths: string[] = []
    const fileIds: string[] = []

    const classifyPath = (videos: Array<{ real_path: string; file_id: string }>) => {
      videos.forEach(item => {
        const filePath = item?.real_path as string
        const isInBuildInDisk = isBuildInPath(filePath)
        fileIds.push(item.file_id)
        if (isInBuildInDisk) {
          inBuildInDiskPaths.push(filePath)
        } else {
          notInBuildInDiskPaths.push(filePath)
        }
      })
    }

    if (isTV) {
      toast({ type: 'loading', message: '正在统计资源情况', duration: 1000 })
      const dramaSeries = await getDramasApi(nfo.scrape_result?.id as number, 200)
      if (dramaSeries?.length) {
        console.log('dramaSeries', dramaSeries)
        classifyPath(dramaSeries)
      }
    } else {
      classifyPath([videoInfo])
    }

    const hasInInBuildInDiskFile = inBuildInDiskPaths.length > 0

    let subTitle = ''
    let content = ''
    if (hasInInBuildInDiskFile) {
      subTitle = '删除的文件将进入“回收站”，7天内可在“回收站”中找回。'
      content = '不放人回收站,直接删除'
    } else {
      content = '删除的文件将从磁盘中永久删除。'
    }

    const onOk = async (isDeleteFile) => {
      const checkStateRet = checkState(true, true, false, true)
      if (checkStateRet) return checkStateRet
      try {
        // 删除内置盘中的文件
        if (inBuildInDiskPaths.length) await deleteHeziFile(inBuildInDiskPaths, hasInInBuildInDiskFile && !isDeleteFile)
        // 删除非内置盘中的文件
        if (notInBuildInDiskPaths.length) await deleteHeziFile(notInBuildInDiskPaths)
        const error = await deleteNFOFromCinemaStore(nfo, fileIds)
        toast({ type: error ? 'error' : 'success', message: error || '删除成功' })
        deleteNFOSuccessCallback && deleteNFOSuccessCallback()
      } catch (err) {
        toast({ type: 'error', message: err || '删除失败' })
        console.log(err)
      }
      return ''
    }

    Modal.Delete({
      title: '确认删除所选文件吗？',
      subTitle: subTitle,
      content: content,
      cancelText: '取消',
      okText: '立即删除',
      loadingText: '删除中...',
      hasCheck: hasInInBuildInDiskFile,
      onOk,
    })
  }
}

// 从片库播放影片
export const playNFO = async (nfo: API_NFO.NFO, videoName: string, cinemaStore, isPlayHistory?: boolean) => {
  // 片库视频播放
  let fileId: string
  if (isPlayHistory) {
    console.log('[片库][最近观看]:', nfo)
    fileId = (nfo.last_record?.file_id || nfo.video_info?.file_id) as string
  } else {
    fileId = nfo.video_info?.file_id as string
  }

  try {
    cinemaStore.setPlaying(true)
    const isOther = nfo.scrape_result?.class === 'other'

    const apiUrl = isOther ? '/drive/v2/files' : '/drive/v1/files'
    const scene = isOther ? 'heziFile' : 'nfo'

    await store.dispatch('getFileInfo', {
      space: 'hezi',
      apiUrl: apiUrl,
      path: nfo.video_info?.real_path || '',
      size: String(nfo.video_info?.file_size),
      id: fileId,
      usage: 'PLAY',
      theme: 'dark',
      scene,
      mime_type: 'video/*',
      name: videoName,
      hash: nfo.video_info?.hash || '',
    })
    // 关闭视频刷新最近播放列表
    console.log('[片库][视频播放]: 关闭视频刷新最近播放列表')
    cinemaStore.refreshRecentNFOList()
  } catch (error) {
    if (error.error_description === 'file_not_found') {
      cinemaStore.deleteNFO(nfo, [fileId])
      toast({ type: 'error', message: '播放失败，请检查文件是否存在' })
    }
  } finally {
    cinemaStore.setPlaying(false)
  }
}

// 从片库刮削信息中获取影片名称
export const computedNFOName = (nfo: API_NFO.NFO) => {
  const scrape_result = nfo.scrape_result
  let name: string | undefined
  if (scrape_result?.short_name) {
    // 如果有short_name，优先使用short_name
    name = scrape_result?.short_name
  } else if (scrape_result?.class !== 'other') {
    // 如果分类不是其他（刮削有结果），使用刮削出来的中文名
    name = scrape_result?.trans_name
  } else {
    // 如果分类是其他（刮削没有结果），使用文件本身的名字
    name = nfo.video_info?.file_name
  }
  // 对要展示的名字进行缩略
  return reduceFilename(name ?? '')
}

// 获取影片上次播放进度
export const computedNFOPlayProgress = (nfo: API_NFO.NFO) => {
  const lastRecord = nfo.last_record
  const videoInfo = nfo.video_info
  const duration = lastRecord?.during || videoInfo?.during || 0
  const current = lastRecord?.viewed_point || Number(videoInfo?.play_seconds) || 0
  return duration ? interceptDigital(100 * current / duration, 1) : 0
}

// 判断影片是否是电视剧
export const computedNFOIsTV = (nfo: API_NFO.NFO) => {
  const scrape_result = nfo.scrape_result
  return (
    (scrape_result?.dramas ?? []).length > 0 || scrape_result?.class === 'tv'
  )
}

// 判断影片是否是电视剧
export const computedNFOIsOther = (nfo: API_NFO.NFO) => {
  const scrape_result = nfo.scrape_result
  return scrape_result?.class === 'other'
}

// 获取影片file_id
export const computedNFOFileId = (nfo: API_NFO.NFO) => {
  return nfo.last_record?.file_id || nfo.video_info?.file_id
}